import { render, staticRenderFns } from "./PayoneerTopUp.vue?vue&type=template&id=569f55c1&"
import script from "./PayoneerTopUp.vue?vue&type=script&lang=js&"
export * from "./PayoneerTopUp.vue?vue&type=script&lang=js&"
import style0 from "./PayoneerTopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports